import PropTypes from 'prop-types';
import React, { Component } from 'react';
import formatPhoneNumber from '../../../common/helpers/formatPhoneNumber';
import RoleAwareLink from '../../../common/RoleAwareLink';
import Icon, { GLYPHS } from '../../../common/icon';
import { fullName } from '../../../common/helpers/users';
import BarberAvatar from '../components/BarberAvatar';
import TimeTracking from '../../timeTracker/containers/BarberListTimeTracking';
import BarberLocations from '../containers/BarberLocations';

class BarbersListItem extends Component {
  onClick(e) {
    e.preventDefault();
  }

  render() {
    const {
      id,
      email,
      phone,
      personnelId,
      bankAccountId,
      shops,
    } = this.props.barber;

    return (
      <RoleAwareLink className="c-table-card__row" to={`/barbers/${id}`}>
        <div
          className="c-table-card__cell u-1/10"
          display-if={this.props.isSortable}
          onClick={this.onClick}
          onTouchMove={this.onClick}
        >
          <div className="c-link-blank u-text-right u-pr- u-align-middle sortable-handle">
            <Icon glyph={GLYPHS.dragDrop} />
          </div>
        </div>
        <div className="c-table-card__cell u-2/10">
          <div className="u-text-trim">
            <span className="c-avatar u-mr--" display-if={!this.props.isBrandView}>
              <BarberAvatar barber={this.props.barber} />
            </span>
            <span className="u-mr--">{fullName(this.props.barber)}</span>
            <Icon glyph={GLYPHS.bank} display-if={!this.props.isBrandView && bankAccountId} />
          </div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-2/10">
          <div className="u-text-trim">{email}</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/10">
          <div className="u-text-trim">{formatPhoneNumber(phone)}</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/10">
          <div className="u-text-trim">{personnelId}</div>
        </div>
        <TimeTracking display-if={!this.props.isBrandView} barberId={id} />
        <BarberLocations locations={shops} display-if={this.props.isBrandView} />
      </RoleAwareLink>
    );
  }
}

BarbersListItem.propTypes = {
  barber: PropTypes.object.isRequired,
  isBrandView: PropTypes.bool.isRequired,
  isSortable: PropTypes.bool.isRequired,
};

export default BarbersListItem;
